import React, { useState } from 'react'
import { css } from '@emotion/css'
import { theme as deprecatedTheme } from '../../../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { Link } from '@contrast-security-inc/design-system-typography'
import { useIntl } from 'react-intl'

const projectCss = css`
  font-family: ${deprecatedTheme.fontFamilies.secondary};
  font-size: 14px;
  color: ${theme.color.neutral100};
  display: inline-block;
  line-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
`

const projectListCss = css`
  list-style-type: none;
  padding: 0;
  margin-bottom: 0;
`

const showMoreLinkCss = css`
  font-size: 12px;
`

const maxProjectList = 3

export const ProjectsCellTooltip = ({
  projectName
}: {
  projectName: string
}) => {
  return (
    <Tooltip placement="top-start" body={projectName} isDelayed>
      <span className={projectCss}>{projectName}</span>
    </Tooltip>
  )
}

export function ProjectsCell({
  projects = [],
  library
}: {
  readonly projects?: string[]
  library?: string
}) {
  const [showAllProjects, setShowAllProjects] = useState(false)
  const { formatMessage } = useIntl()
  const visibleProjects = showAllProjects
    ? projects
    : projects.slice(0, maxProjectList)
  const shouldShowMore = projects.length - maxProjectList > 0

  return (
    <>
      <ul className={projectListCss}>
        {visibleProjects.map((project) => (
          <li key={project}>
            <ProjectsCellTooltip projectName={project} />
          </li>
        ))}
      </ul>
      {shouldShowMore && (
        <>
          {!showAllProjects ? (
            <Link
              className={showMoreLinkCss}
              testId={`projects-cell-${library}-show-more`}
              onClick={() => setShowAllProjects(true)}
            >
              {formatMessage(
                { id: 'action_showAllWithTotal' },
                { total: projects.length }
              )}
            </Link>
          ) : (
            <Link
              className={showMoreLinkCss}
              onClick={() => setShowAllProjects(false)}
              testId={`projects-cell-${library}-show-less`}
            >
              {formatMessage({ id: 'action_showLess' })}
            </Link>
          )}
        </>
      )}
    </>
  )
}
